<template>
  <div>
    <Select v-model="selected"
            :loading="loading"
            :remote-method="searchCompany"
            @on-change="handleValueChanged"
            filterable
            clearable>
      <Option v-for="c in results" :key="c.id" :value="c.id" :label="c.name"></Option>
    </Select>
    <div class="text-align-right" style="font-size: 12px; color: rgb(128, 134, 149)">Not found? <a href="/companies/list" target="_blank">Add one</a>.</div>
  </div>
</template>

<script>
import { eloquentsearch } from '@/api/search'
export default {
  name: 'CompanySelect',
  data () {
    return {
      selected: this.$attrs.value,
      results: [],
      loading: false
    }
  },
  methods: {
    searchCompany (query) {
      this.loading = true
      eloquentsearch('company', query)
        .then(resp => {
          this.results = resp.data.data
        }).finally(() => {
          this.loading = false
        })
    },
    handleValueChanged (value) {
      const companyInfo = _.find(this.results, { id: value })
      this.$emit('input', value)
      this.$emit('update:company', companyInfo)
      this.$emit('update:name', companyInfo.name)
    }
  },
  watch: {
    '$attrs.value' () {
      this.selected = this.$attrs.value
    }
  }
}
</script>
